import { ChangeEvent } from 'react';

// --- Types ---

export interface Position {
    Security?: {
        Id?: number | string;
        Name?: string;
    };
}

export interface AdaptAllocationsParams {
    data?: {
        Positions?: Position[]
    };
    // Replaced 'unknown' with specific shapes used in your component
    onAllocationChange: (value: { id: number | string; value: number }) => void;
    onCheckBoxChange: (value: { checked: boolean; id: number | string }) => void;
    t: (key: string) => string;
}

export interface AdaptedTableData {
    body: Array<{
        id: number | string | undefined;
        name: {
            label: string | undefined;
            checked: boolean;
            onChange: (e: ChangeEvent<HTMLInputElement>) => void;
        };
        allocation: {
            id: number | string | undefined;
            value: number;
            onChange: (value: { id: number | string; value: number }) => void;
            disabled: boolean;
        };
        factsheet: {
            securityId: number | string | undefined;
        };
    }>;
    footer: {
        name?: string;
        allocation?: number;
    };
}

// --- Mapper Function ---

export const adaptAllocations = ({
    data,
    onAllocationChange,
    onCheckBoxChange,
    t,
}: AdaptAllocationsParams): AdaptedTableData => {
    const total = 0;
    const tableData: AdaptedTableData = { body: [], footer: {} };

    data?.Positions?.forEach((item) => {
        const securityId = item?.Security?.Id;

        tableData.body.push({
            id: securityId,
            name: {
                label: item?.Security?.Name,
                checked: false,
                // Properly typed event
                onChange: (e: ChangeEvent<HTMLInputElement>) => onCheckBoxChange({
                    checked: e.target.checked,
                    id: securityId as string | number,
                }),
            },
            allocation: {
                id: securityId,
                value: 0,
                onChange: onAllocationChange as any, // Cast if the slider emits the same shape
                disabled: true,
            },
            factsheet: {
                securityId,
            },
        });
    });

    // Moved outside forEach since total doesn't change per-iteration in this initial state
    tableData.footer = {
        name: t('portfolio.createNewPortfolio.allocations.total'),
        allocation: total,
    };

    return tableData;
};
